

/// <reference path="StockNoteLine.ts" />

// Generated class DeliveryOrderLine_ManagedObject

class DeliveryOrderLine_ManagedObject extends StockNoteLine
{

    // Property: hasErrors
    set hasErrors(value:boolean) {
        this.setValueForKey(value, 'hasErrors');
    }
    get hasErrors():boolean {
        return this.valueForKey('hasErrors');
    }
    set hasErrorsPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'hasErrors');
    }
    get hasErrorsPrimitiveValue():boolean {
        return this.primitiveValueForKey('hasErrors');
    }

    // Property: measureFormatError
    set measureFormatError(value:string) {
        this.setValueForKey(value, 'measureFormatError');
    }
    get measureFormatError():string {
        return this.valueForKey('measureFormatError');
    }
    set measureFormatErrorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'measureFormatError');
    }
    get measureFormatErrorPrimitiveValue():string {
        return this.primitiveValueForKey('measureFormatError');
    }

    // Property: orderMeasureFormat
    set orderMeasureFormat(value:string) {
        this.setValueForKey(value, 'orderMeasureFormat');
    }
    get orderMeasureFormat():string {
        return this.valueForKey('orderMeasureFormat');
    }
    set orderMeasureFormatPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'orderMeasureFormat');
    }
    get orderMeasureFormatPrimitiveValue():string {
        return this.primitiveValueForKey('orderMeasureFormat');
    }

    // Property: orderPrice
    set orderPrice(value:number) {
        this.setValueForKey(value, 'orderPrice');
    }
    get orderPrice():number {
        return this.valueForKey('orderPrice');
    }
    set orderPricePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderPrice');
    }
    get orderPricePrimitiveValue():number {
        return this.primitiveValueForKey('orderPrice');
    }

    // Property: orderProductName
    set orderProductName(value:string) {
        this.setValueForKey(value, 'orderProductName');
    }
    get orderProductName():string {
        return this.valueForKey('orderProductName');
    }
    set orderProductNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'orderProductName');
    }
    get orderProductNamePrimitiveValue():string {
        return this.primitiveValueForKey('orderProductName');
    }

    // Property: orderProductPrice
    set orderProductPrice(value:number) {
        this.setValueForKey(value, 'orderProductPrice');
    }
    get orderProductPrice():number {
        return this.valueForKey('orderProductPrice');
    }
    set orderProductPricePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderProductPrice');
    }
    get orderProductPricePrimitiveValue():number {
        return this.primitiveValueForKey('orderProductPrice');
    }

    // Property: orderProductReference
    set orderProductReference(value:string) {
        this.setValueForKey(value, 'orderProductReference');
    }
    get orderProductReference():string {
        return this.valueForKey('orderProductReference');
    }
    set orderProductReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'orderProductReference');
    }
    get orderProductReferencePrimitiveValue():string {
        return this.primitiveValueForKey('orderProductReference');
    }

    // Property: productError
    set productError(value:string) {
        this.setValueForKey(value, 'productError');
    }
    get productError():string {
        return this.valueForKey('productError');
    }
    set productErrorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'productError');
    }
    get productErrorPrimitiveValue():string {
        return this.primitiveValueForKey('productError');
    }
    // Relationship: selectedProduct
    set selectedProduct(value:Product) {
        this.setValueForKey(value, 'selectedProduct');
    }
    get selectedProduct():Product {
        return this.valueForKey('selectedProduct') as Product;
    }
}
